import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ZonaProvider } from "./context/ZonaContext.js";

import {
  ListPersona,
  AddPersona,
  EditPersona,
  PrivateMainPage,
  AddPais,
  AddTipoDocumento,
  AddTipoDomicilio,
  AddEstado,
  AddPatologia,
  AddSintomas,
  AddEstadosPorPatologia,
  AddEstadosTratamiento,
  AddEstadosTratamientoPorPatologia,
  AddSintomasPorPatologia,
  PublicMainPage,
  PublicRoute,
  PrivateRoute,
  LoginUsuario,
  AddUser,
  Casos,
  Grafos,
  GrafosEnfoque,
  Relaciones,
  AddTiposRelacion,
  AddFechasSeguimiento,
  ListadoCasosContactos,
  Informe,
  GIS,
  FormularioRegistro,
  AddComorbilidadesXPatologia,
  AddComorbilidadPorPatologia,
  AddPersonaData,
  AddNivelesRiesgo,
  AddEstudios,
  AddEstudiosXPatologia,
  AddContactos,
  AddAtributos,
  Seguimiento,
  AddAtributosPorPatologia,
  AddDiagnostico,
  AddDiagnosticoPorPatologia,
  ZonasSanitarias,
  ZonasGeograficas,
  ControlSeguimiento,
  AddVacunasPorPatologia,
  AddMedicacionPorPatologia,
  AddVacunas,
  AddEstablecimientosDiagnostico,
  AddInstitucionesSeguimientoTratamiento,
  AddEvolucionesClinicoTerapeuticas,
  AddMedicaciones,
  AddGruposEtarios,
  AreasProgramaticas,
  SectoresSubsectores,
  Reglas,
  AdministracionUsuarios,
  CrearPerfilPage,
  NoAutorizado,
  ApacheSuperset,
} from "./imports";
import LandingPage from "./components/pages/LandingPage";
import GenerarInforme from './components/GenerarInforme.js';
import { AuthContextProvider } from "./context/authContext.js";
import { NavbarV2 } from "./navigation/NavbarV2";
import PermissionRoute from "./components/router/PermissionRoute";
import { PERMISSIONS } from "./config/permissions";
import './css/App.css';
import './css/PrivateCompact.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { PatologiaProvider } from "./context/PatologiaContext.js";

const AppContent = () => {
  const location = useLocation();

  // Rutas donde NO quieres mostrar el navbar
    const noNavbarRoutes = ["/", "/login", ];

  // Mostrar navbar solo si la ruta actual NO está en noNavbarRoutes
  const showNavbar = !noNavbarRoutes.includes(location.pathname);
  const normalizedPath = location.pathname.toLowerCase();
  const isPrivateRoute = normalizedPath.startsWith('/privatemainpage');
  const isFullSizePrivateView =
    normalizedPath.startsWith('/privatemainpage/grafos') ||
    normalizedPath.startsWith('/privatemainpage/gis');
  const privateContentClass =
    isPrivateRoute && !isFullSizePrivateView ? 'private-content--compact' : '';

  return (
    <>
      {showNavbar && <NavbarV2 />}
      <main className={privateContentClass}>
        <Routes>
  <Route path="/" element={<LandingPage />} />  
  
       <Route path="/" element={<PublicRoute />}>
          
          <Route path="login" element={<LoginUsuario />} />
          <Route path="register" element={<FormularioRegistro />} />
        </Route>

          <Route path="PrivateMainPage" element={<PrivateRoute />}>
            <Route index element={<PrivateMainPage />} />
            <Route path="casos" element={<Casos />} />
             <Route path="register" element={<FormularioRegistro />} />
            <Route path="listPersona" element={<ListPersona />} />
            <Route path="addPersona" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ADD_PERSONA}><AddPersona /></PermissionRoute>} />
            <Route path="addPais" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ADD_PAIS}><AddPais /></PermissionRoute>} />
            <Route path="addTipoDocumento" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ADD_TIPO_DOCUMENTO}><AddTipoDocumento /></PermissionRoute>} />
            <Route path="addTipoDomicilio" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ADD_TIPO_DOMICILIO}><AddTipoDomicilio /></PermissionRoute>} />
            <Route path="edit/:IdPersona" element={<EditPersona />} />
            <Route path="addEstado" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ADD_ESTADO}><AddEstado /></PermissionRoute>} />
            <Route path="addPatologia" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ADD_PATOLOGIA}><AddPatologia /></PermissionRoute>} />
            <Route path="addSintomas" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ADD_SINTOMAS}><AddSintomas /></PermissionRoute>} />
            <Route path="addEstadoPorPatologia" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ADD_ESTADO_PATOLOGIA}><AddEstadosPorPatologia /></PermissionRoute>} />
            <Route path="addEstadoTratamiento" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ADD_ESTADO}><AddEstadosTratamiento /></PermissionRoute>} />
            <Route path="addEstadoTratamientoPorPatologia" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ADD_ESTADO_PATOLOGIA}><AddEstadosTratamientoPorPatologia /></PermissionRoute>} />
            <Route path="addSintomaPorPatologia" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ADD_SINTOMA_PATOLOGIA}><AddSintomasPorPatologia /></PermissionRoute>} />
            <Route path="addComorbilidadPorPatologia" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ADD_COMORBILIDAD_PATOLOGIA}><AddComorbilidadPorPatologia /></PermissionRoute>} />
            <Route path="addComorbilidad" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ADD_COMORBILIDAD}><AddComorbilidadesXPatologia /></PermissionRoute>} />
            <Route path="editPersonaData/:IdPersona" element={<AddPersonaData />} />
            <Route path="addNivelesRiesgo" element={<AddNivelesRiesgo />} />
            <Route path="addEstudios" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ADD_ESTUDIOS}><AddEstudios /></PermissionRoute>} />
            <Route path="grafos" element={<PermissionRoute permission={PERMISSIONS.GRAPHS_READ}><Grafos /></PermissionRoute>} />
            <Route path="grafos/:idPersona" element={<GrafosEnfoque />} />
            <Route path="AddTiposRelacion" element={<AddTiposRelacion />} />
            <Route path="AddFechasSeguimiento" element={<AddFechasSeguimiento />} />
            <Route path="FormularioRegistro" element={<PermissionRoute permission={PERMISSIONS.USERS_CREATE}><FormularioRegistro /></PermissionRoute>} />
            <Route path="ListadoCasosContactos" element={<PermissionRoute permission={PERMISSIONS.PATIENTS_READ}><ListadoCasosContactos /></PermissionRoute>} />
            <Route path="Relaciones" element={<Relaciones />} />
            <Route path="informe" element={<PermissionRoute permission={PERMISSIONS.REPORTS_READ}><Informe /></PermissionRoute>} />
            <Route path="generarInforme" element={<GenerarInforme />} />
            <Route path="GIS" element={<PermissionRoute permission={PERMISSIONS.GIS_READ}><GIS /></PermissionRoute>} />
            <Route path="Seguimiento/:idPersona" element={<Seguimiento />} />
            <Route path="addContactos" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ADD_CONTACTOS}><AddContactos /></PermissionRoute>} />
            <Route path="addAtributos" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ADD_ATRIBUTOS}><AddAtributos /></PermissionRoute>} />
            <Route path="addAtributoPorPatologia" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ADD_ATRIBUTO_PATOLOGIA}><AddAtributosPorPatologia /></PermissionRoute>} />
            <Route path="addDiagnostico" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ADD_ATRIBUTOS}><AddDiagnostico /></PermissionRoute>} />
            <Route path="addDiagnosticoPorPatologia" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ADD_ATRIBUTO_PATOLOGIA}><AddDiagnosticoPorPatologia /></PermissionRoute>} />
          <Route path="ControlSeguimiento/:idPersona" element={<ControlSeguimiento />} />
            <Route path="addEstudioPorPatologia" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ADD_ESTUDIO_PATOLOGIA}><AddEstudiosXPatologia /></PermissionRoute>} />
            <Route path="zonas-sanitarias" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ZONAS_SANITARIAS}><ZonasSanitarias /></PermissionRoute>} />
            <Route path="zonas-geograficas" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ZONAS_GEOGRAFICAS}><ZonasGeograficas /></PermissionRoute>} />
            <Route path="addVacunas" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ADD_VACUNAS}><AddVacunas /></PermissionRoute>} />
            <Route path="establecimientos-diagnostico" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ESTABLECIMIENTOS_DIAGNOSTICO}><AddEstablecimientosDiagnostico /></PermissionRoute>} />
            <Route path="instituciones-seguimiento-tratamiento" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_INSTITUCIONES_SEGUIMIENTO_TRATAMIENTO}><AddInstitucionesSeguimientoTratamiento /></PermissionRoute>} />
            <Route path="evoluciones-clinico-terapeuticas" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_EVOLUCIONES_CLINICO_TERAPEUTICAS}><AddEvolucionesClinicoTerapeuticas /></PermissionRoute>} />
            <Route path="addMedicaciones" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ADD_MEDICACIONES}><AddMedicaciones /></PermissionRoute>} />
            <Route path="addGruposEtarios" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_GRUPOS_ETARIOS}><AddGruposEtarios /></PermissionRoute>} />
            <Route path="areas-programaticas" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_AREAS_PROGRAMATICAS}><AreasProgramaticas /></PermissionRoute>} />
            <Route path="sectores-subsectores" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_SECTORES_SUBSECTORES}><SectoresSubsectores /></PermissionRoute>} />
            <Route
  path="AddVacunasPorPatologia"
  element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ADD_VACUNAS_PATOLOGIA}><AddVacunasPorPatologia /></PermissionRoute>}
/>
<Route
  path="AddMedicacionPorPatologia"
  element={<PermissionRoute permission={PERMISSIONS.SUBMENU_ADD_MEDICACION_PATOLOGIA}><AddMedicacionPorPatologia /></PermissionRoute>}
/>
            <Route path="reglas" element={<PermissionRoute permission={PERMISSIONS.RULES_READ}><Reglas /></PermissionRoute>} />            <Route path="administracion-usuarios" element={<PermissionRoute permission={PERMISSIONS.USERS_READ}><AdministracionUsuarios /></PermissionRoute>} />            <Route path="crear-perfil" element={<PermissionRoute permission={PERMISSIONS.SUBMENU_CREAR_PERFIL}><CrearPerfilPage /></PermissionRoute>} />
            <Route path="apachesuperset" element={<ApacheSuperset />} />
            <Route path="no-autorizado" element={<NoAutorizado />} />

          </Route>
      </Routes>
      </main>
    </>
  );
};

const App = () => {
  return (
    <AuthContextProvider>
      <PatologiaProvider>
         <ZonaProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
      </ZonaProvider>
      </PatologiaProvider>
    </AuthContextProvider>
  );
};

export default App;
